import { Accordion, Button } from 'react-bootstrap';
import Modal from '../../../components/Modal';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import SkeletonGrid from '../../../components/SkeletonLoader/SkeletonGrid';
import React from 'react';

const QuestionAnswerPreviewModal = ({
  isOpen,
  onClose,
  details,
  handleSelectQuestion,
  fromQuestionSearch,
  isLoading
}) => {

  const titledResourcesCount = details?.resources?.filter(r => r.selectionTitle)?.length ?? 0;

  const handlePlayVideo = (e, videoId) => {
    e.stopPropagation();
    var videoButton = document.getElementById(`videoButton${videoId}`);
    var videoPlayer = document.getElementById(`video${videoId}`);
    var showVideo = videoPlayer.style.display == 'none';
    
    if (!showVideo) videoPlayer.pause();
    videoButton.innerHTML = showVideo ? 'Hide video' : 'Show video';
    videoPlayer.style.display = showVideo ? 'inline-block' : 'none';
  };

  function getSelectionTitle(selectionTitle, index, totalCount) {
    if (!selectionTitle) return selectionTitle;
    const cleanName = removePTags(selectionTitle);
    return totalCount > 1 ? `${cleanName} (${index + 1})` : cleanName;
  }

  function removePTags(inputString) {
    return inputString.replace(/^<p>|<\/p>$/g, '');
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      titleName='Question Preview'
      contentWidth='60%'>
      {isLoading ?
        (
          <SkeletonGrid
            rowCount={2}
            colCount={1}
            className='p-5 mt-4'/>
        ):(
          <div className='d-flex flex-column'>
            {fromQuestionSearch &&
        <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
          <span>{`ID: ${details.questionSource}${details.questionId}`}</span>
          <div className='d-flex flex-row'>
            <span>{`[Level: ${details.level}, Correct: ${details.correct}, Incorrect: ${details.incorrect}]`}</span>
            {details.answer &&
                <>
                  <span className='mx-3' style={{ border: '1px solid #8c8c8c33' }}></span>
                  <span className='answer-text'>{`Answer: ${details.answer}`}</span>
                </>}
          </div>
        </div>
            }
            {details.resources?.length >= 1 &&
            <div className='mb-3'>
              {(() => {
                let titledIndex = 0;
                return details.resources.map((resource, index) => {
                  if (resource.description.toLowerCase().includes('document missing')) {
                    return (
                      <div key={index} className='text-danger'>{resource.description}</div>
                    );
                  }

                  const currentTitledIndex = resource.selectionTitle ? titledIndex++ : null;

                  return (
                    <React.Fragment key={`resource${index}`}>
                      {resource.selectionTitle &&
                      <Accordion>
                        <Accordion.Header>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getSelectionTitle(resource.selectionTitle, currentTitledIndex, titledResourcesCount),
                            }}
                          ></div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                        </Accordion.Body>
                      </Accordion>
                      }

                      {!resource.selectionTitle && !resource.mp3Path &&
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                      }

                      {resource.imagePath &&
                          <img src={resource.imagePath }/>
                      }
                      {!resource.selectionTitle && resource.mp3Path &&
                      <div className='d-flex flex-column'>
                        {resource.description && <div className='border-black p-1' dangerouslySetInnerHTML={{ __html: resource.description }}></div>}
                        {resource.mp3Path && 
                          <>
                            <audio style={{ maxWidth: '98%' }} controls='controls' src={resource.mp3Path} type='audio/mpeg' ></audio>
                            <div className='d-flex align-items-center gap-2 mt-3 mb-2 audio-notice'>
                              <FontAwesomeIcon icon={faCircleInfo} className='text-primary' />
                              <span className='audio-notice-description'>&quot;Students will not see the reading selection text and will have to listen to the audio file.&quot;</span>
                            </div>
                          </>
                        }
                      </div>}

                      {!resource.selectionTitle && resource.mp4Path &&
                      <div className='d-flex flex-column'>
                        <video id={`video${index}`} controls className='mb-2' src={resource.mp4Path} type='video/mp4' />
                        <Button variant='castleWhite' id={`videoButton${index}`} onClick={(e) => handlePlayVideo(e, index)}>Hide Video</Button>
                      </div>
                      }
                    </React.Fragment>
                  );
                });
              })()}
            </div>
            }

            {(details.questionType != 1 || !details.mcAnswers || details.mcAnswers.length <= 0) && <div dangerouslySetInnerHTML={{ __html: details.question }}></div>}
            {details.questionType === 1 && details.mcAnswers?.length >= 1 &&
            <div className='d-flex flex-column'>
              <div className='mb-2' dangerouslySetInnerHTML={{ __html: details.mcQuestion }}></div>
              {details.mcAnswers.map((item, index) => {
                return (
                  <div className={`d-flex flex-row align-items-center mb-2 mcAnswer ${item.correct === 1 ? 'correct' : ''}`} key={`mcAnswer_${index}`}>
                    {item.correct === 1 && <FontAwesomeIcon color='#52C9A5' icon={faSquareCheck} />}
                    {item.correct != 1 && <FontAwesomeIcon color='#F3F5F9' icon={faSquare} />}

                    <div className='mx-2' id={`mcAnswer_${index}_label`}>{`${index + 1}.`}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                  </div>
                );
              })}
            </div>}
            {details.answer && !fromQuestionSearch &&
                <div className='mt-4 answer-text'>{`Answer: ${details.answer}`}</div>
            }
            {details.sampleAnswer &&
            <Accordion>
              <Accordion.Header>Sample Answer</Accordion.Header>
              <Accordion.Body>
                <div dangerouslySetInnerHTML={{ __html: details.sampleAnswer }}></div>
              </Accordion.Body>
            </Accordion>
            }
            {fromQuestionSearch &&
        <div className='d-flex flex-row justify-content-end'>
          <Button className='mt-3' variant='castleRed' style={{ width: '15%' }} disabled={details.inAssignment} onClick={(e) => { handleSelectQuestion(details, e); onClose(false); }}>{`${details.isSelected ? 'Unselect Question' : 'Select Question'}`}</Button>
        </div>
            }
          </div>
        )}
    </Modal>
  );
};

QuestionAnswerPreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  details: PropTypes.object,
  handleSelectQuestion: PropTypes.func,
  fromQuestionSearch: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default QuestionAnswerPreviewModal;
